import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询杂项费收退款台账
export function queryMiscFeeLedger(params) {
  params.communityId = getCommunityId()
  return new Promise((resolve, reject) => {
    request({
      url: '/reportFeeMonthStatistics.queryMiscFeeLedger',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出杂项费收退款台账
export function exportData(params) {
  params.communityId = getCommunityId()
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
